import React from 'react';

import ComingSoon from '../../../common/component/ComingSoon/ComingSoon';

const Empty = () => {
    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageEmpty" className="py-5 my-5">
            <ComingSoon/>
        </div>
    )
}

export default Empty;